import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Typography } from "@mui/material";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import "../App.css";
import CtTxt from "../Components/CustomTool/CtTxt";
import CtBtn from "../Components/CustomTool/CtBtn";
import MaterialTable from "../Components/CustomTool/MaterialTable";
import "./Table.css";
import { apiURL, fetchProposal } from "../Components/API";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import {
  applyTrimOnObjectValues,
  csvFileName,
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
  getRowOfRT,
  isValidItem,
  validatedate_min_max,
  validateEmail,
} from "../SystemUtility/SystemUtility";
import ProposalEntry from "./ProposalEntry";
import { withRouter } from "../HOC/withRouter";
import { connect } from "react-redux";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import CtDtp from "./CustomTool/CtDtp";
import CtART from "./CustomTool/ResponsiveTable";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import { FileCopy } from "@mui/icons-material";
import SaveIcon from "@mui/icons-material/Save";
import JSZip from "jszip";

const PROPOSAL_PAGE_SIZE = 20;
const SEQUENCE_FROM_DATE = "2000-01-01";

class Proposal extends Component {
  isProposalListLoading = false;

  state = {
    selectedProposalRows: [],
    columnsdata: [
      {
        accessorKey: "bint_summarysrno",
        header: "Sr No",
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 60,
      },
      {
        accessorKey: "vac_brname",
        header: "Branch Name",
      },
      {
        accessorKey: "vac_summary_refno",
        header: "Ref No.",
        size: 150,
      },
      {
        accessorKey: "Date",
        header: "Date",
        size: 110,
      },
      {
        accessorKey: "dat_date_YMD",
        header: "Date",
      },
      {
        accessorKey: "vac_sitename",
        header: "Site Name",
      },
      {
        accessorKey: "vac_name",
        header: "Customer Name",
        size: 200,
      },
      {
        accessorKey: "vac_mobileno",
        header: "Cust. Mobile No.",
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 140,
      },
      {
        accessorKey: "bint_totalliftcount",
        header: "No. Of Lift",
        enableColumnActions: false,
        enableResizing: false,
        enableColumnDragging: false,
        size: 110,
      },
      {
        accessorKey: "TblYear",
        header: "TblYear",
      },
      {
        accessorKey: "vac_brcode",
        header: "vac_brcode",
      },
    ],
    selectedRow: [],
    showRevisedDialog: false,
    Branches: [],
    dateRows: [],
    sequenceRows: [],
    dateHasMore: false,
    sequenceHasMore: false,
    dateTotalCount: 0,
    sequenceTotalCount: 0,
    formData: {
      listTab: "date",
      dtpRevisedDate: get_YMD_from_SYS(new Date()),
      dtpfromdate:
        localStorage.getItem("proposalFromDate") &&
        Math.floor(
          (new Date() - new Date(localStorage.getItem("setFromDateTime"))) /
            (1000 * 60),
        ) <= 30
          ? localStorage.getItem("proposalFromDate")
          : get_30DaysBack_FromCurrentDate(new Date()),
      dtptodate:
        localStorage.getItem("proposalToDate") &&
        Math.floor(
          (new Date() - new Date(localStorage.getItem("setTodateTime"))) /
            (1000 * 60),
        ) <= 30
          ? localStorage.getItem("proposalToDate")
          : get_YMD_from_SYS(new Date()),
      cmbDateBranch:
        localStorage.getItem("proposalBranch") &&
        Math.floor(
          (new Date() - new Date(localStorage.getItem("setBranchTime"))) /
            (1000 * 60),
        ) <= 30
          ? localStorage.getItem("proposalBranch")
          : "ALL",
      cmbSequenceBranch:
        localStorage.getItem("proposalBranch") &&
        Math.floor(
          (new Date() - new Date(localStorage.getItem("setBranchTime"))) /
            (1000 * 60),
        ) <= 30
          ? localStorage.getItem("proposalBranch")
          : "ALL",
      txtSiteSearch: "",
    },
    childValues: {},
    rowsPerPage: PROPOSAL_PAGE_SIZE,
    ARD: null,
  };

  componentDidMount() {
    localStorage.setItem("Heading", "Proposal");
    this.props.verifyUserID(
      this.getInfo,
      this.props.setUserPrivileges,
      this.props.modules.proposal,
    );
  }

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadProposalData",
      vac_userid: localStorage.getItem("vac_userid"),
    };
    fetchProposal(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let Branches = res.data.Branch.length > 0 ? res.data.Branch : [];
        Branches.unshift({ vac_brname: "ALL" });
        this.setState(
          {
            Branches,
          },
          () => {
            this.loadProposalList("date");
          },
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
  };

  getBranchList = (branchValue) => {
    if (branchValue == "ALL") {
      return this.state.Branches.filter(
        (branch) => branch.vac_brname !== "ALL",
      );
    }
    return [{ vac_brname: branchValue }];
  };

  validateBranch = (branchValue, controlId) => {
    if (branchValue.length <= 0) {
      this.props.toastErrorMsg("Select Branch", controlId);
      return false;
    }
    if (!isValidItem(this.state.Branches, "vac_brname", branchValue)) {
      this.props.toastErrorMsg("Select Valid Branch", controlId);
      return false;
    }
    return true;
  };

  validateDateTab = () => {
    const { dtpfromdate, dtptodate, cmbDateBranch } = this.state.formData;
    if (dtpfromdate.length <= 0) {
      this.props.toastErrorMsg("Select From Date", "dtpfromdate");
      return false;
    }
    if (dtptodate.length <= 0) {
      this.props.toastErrorMsg("Select To Date", "dtptodate");
      return false;
    }
    if (dtptodate < dtpfromdate) {
      this.props.toastErrorMsg("To Date Is Grater Then From Date", "dtptodate");
      return false;
    }
    return this.validateBranch(cmbDateBranch, "cmbDateBranch");
  };

  validateSequenceTab = () => {
    return this.validateBranch(
      this.state.formData.cmbSequenceBranch,
      "cmbSequenceBranch",
    );
  };

  getCurrentRows = () => {
    return this.state.formData.listTab === "date"
      ? this.state.dateRows
      : this.state.sequenceRows;
  };

  getCurrentHasMore = () => {
    return this.state.formData.listTab === "date"
      ? this.state.dateHasMore
      : this.state.sequenceHasMore;
  };

  getCurrentTotalCount = () => {
    return this.state.formData.listTab === "date"
      ? this.state.dateTotalCount
      : this.state.sequenceTotalCount;
  };

  loadProposalList = (tabKey = this.state.formData.listTab, append = false) => {
    const isDateTab = tabKey === "date";
    if (isDateTab ? !this.validateDateTab() : !this.validateSequenceTab()) {
      return;
    }

    if (this.isProposalListLoading) {
      return;
    }

    const currentRows = isDateTab
      ? this.state.dateRows
      : this.state.sequenceRows;
    const branchValue = isDateTab
      ? this.state.formData.cmbDateBranch
      : this.state.formData.cmbSequenceBranch;
    const skip = append ? currentRows.length : 0;

    this.isProposalListLoading = true;
    this.props.notifyProcessing();
    const reqData = {
      Op: "ProposalSummaryList",
      dat_fromdate: isDateTab
        ? this.state.formData.dtpfromdate
        : SEQUENCE_FROM_DATE,
      dat_todate: isDateTab
        ? this.state.formData.dtptodate
        : get_YMD_from_SYS(new Date()),
      erp_role: localStorage.getItem("ErpRole"),
      vac_userid: localStorage.getItem("vac_userid"),
      vac_branchname: this.getBranchList(branchValue),
      vac_sitename: isDateTab ? "" : this.state.formData.txtSiteSearch,
      sort_mode: isDateTab ? "date" : "sequence",
      int_skip: skip,
      int_limit: PROPOSAL_PAGE_SIZE,
    };

    fetchProposal(reqData)
      .then((res) => {
        this.isProposalListLoading = false;
        this.props.closeUpdateProcessing();
        const ProposalSummaryList =
          res.data.ProposalSummaryList &&
          res.data.ProposalSummaryList.length > 0
            ? res.data.ProposalSummaryList
            : [];
        const rows = append
          ? [...currentRows, ...ProposalSummaryList]
          : ProposalSummaryList;
        const stateUpdate = isDateTab
          ? {
              dateRows: rows,
              dateHasMore: res.data.hasMore === true,
              dateTotalCount: Number(res.data.totalCount || 0),
            }
          : {
              sequenceRows: rows,
              sequenceHasMore: res.data.hasMore === true,
              sequenceTotalCount: Number(res.data.totalCount || 0),
            };

        this.setState({
          ...stateUpdate,
          selectedProposalRows: append ? this.state.selectedProposalRows : [],
        });
      })
      .catch((error) => {
        this.isProposalListLoading = false;
        console.log("Unknown error occurred in onFormLoad.", error);
        this.props.closeUpdateProcessing();
      });
  };

  handleProposalTableScroll = (event) => {
    const { scrollHeight, scrollTop, clientHeight } = event.currentTarget;
    const isNearBottom = scrollHeight - scrollTop - clientHeight < 100;

    if (isNearBottom && this.getCurrentHasMore()) {
      this.loadProposalList(this.state.formData.listTab, true);
    }
  };

  refreshCurrentTab = () => {
    this.loadProposalList(this.state.formData.listTab, false);
  };

  DeleteData = (vac_refno, bint_summarysrno, dat_date, vac_brname) => {
    if (bint_summarysrno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Proposal Ref No : " + vac_refno + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteproposalData(
                bint_summarysrno,
                dat_date,
                vac_brname,
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteproposalData = (bint_summarysrno, dat_date, vac_brname) => {
    const currentBranchValue =
      this.state.formData.listTab === "date"
        ? this.state.formData.cmbDateBranch
        : this.state.formData.cmbSequenceBranch;

    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteProposalData",
      bint_summarysrno: bint_summarysrno,
      vac_branchname: vac_brname,
      vac_dataloadbranch: this.getBranchList(currentBranchValue),
      dat_date: dat_date,
      dat_fromdate: this.state.formData.dtpfromdate,
      dat_todate: this.state.formData.dtptodate,
    };
    fetchProposal(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          this.setState(
            {
              ARD: null,
              selectedProposalRows: [],
            },
            () => {
              this.refreshCurrentTab();
            },
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Proposal Data. " + error,
        );
      });
    return false;
  };

  handleOnChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      {
        formData: { ...this.state.formData, [name]: value },
      },
      () => {
        if (name == "dtpfromdate") {
          localStorage.setItem("proposalFromDate", value);
          localStorage.setItem("setFromDateTime", new Date());
        } else if (name == "dtptodate") {
          localStorage.setItem("proposalToDate", value);
          localStorage.setItem("setTodateTime", new Date());
        } else if (name == "cmbDateBranch" || name == "cmbSequenceBranch") {
          localStorage.setItem("proposalBranch", value);
          localStorage.setItem("setBranchTime", new Date());
        }
      },
    );
  };

  handleProposalCheckbox = (row) => {
    const rowData = row.original;

    this.setState((prevState) => {
      const isSelected = prevState.selectedProposalRows.some(
        (item) =>
          item.bint_summarysrno === rowData.bint_summarysrno &&
          item.vac_brname === rowData.vac_brname &&
          item.TblYear === rowData.TblYear,
      );

      return {
        selectedProposalRows: isSelected
          ? prevState.selectedProposalRows.filter(
              (item) =>
                !(
                  item.bint_summarysrno === rowData.bint_summarysrno &&
                  item.vac_brname === rowData.vac_brname &&
                  item.TblYear === rowData.TblYear
                ),
            )
          : [...prevState.selectedProposalRows, rowData],
      };
    });
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "vac_summary_refno",
      "bint_summarysrno",
      "dat_date_YMD",
      "vac_brname",
    ]);
    this.DeleteData(
      row.vac_summary_refno,
      row.bint_summarysrno,
      row.dat_date_YMD,
      row.vac_brname,
    );
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_summarysrno",
      "vac_brname",
      "dat_date_YMD",
      "TblYear",
      "vac_brcode",
    ]);
    this.props.navigateTo("ProposalAllEntry", {
      bint_summarysrno: row.bint_summarysrno,
      cmbBranch: row.vac_brname,
      dtpDate: row.dat_date_YMD,
      TblYear: row.TblYear,
      vac_brcode: row.vac_brcode,
    });
  };

  print = (rtRow, formate) => {
    const row = getRowOfRT(rtRow, ["TblYear", "vac_summary_refno"]);
    let reqData = [
      { name: "year", value: row.TblYear },
      { name: "vac_refno", value: row.vac_summary_refno },
      { name: "formate", value: formate },
    ];

    let queryString = reqData
      .map(
        (data) =>
          encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value),
      )
      .join("&");

    let popupURL = apiURL + "Print?" + queryString;

    window.open(
      popupURL,
      "Print",
      "width=" +
        window.screen.availWidth +
        ",height=" +
        window.screen.availHeight,
    );
    this.props.updateProcessing("success", "PDF Open in popup.");
  };

  revised = (
    bint_summarysrno,
    vac_summary_refno,
    vac_branchname,
    dat_date_YMD,
    revisedDate,
  ) => {
    const currentBranchValue =
      this.state.formData.listTab === "date"
        ? this.state.formData.cmbDateBranch
        : this.state.formData.cmbSequenceBranch;

    this.props.notifyProcessing();
    const reqData = {
      Op: "GenerataRivisedProposal",
      bint_summarysrno: bint_summarysrno,
      dat_date: dat_date_YMD,
      vac_summary_refno: vac_summary_refno,
      vac_branchname,
      vac_dataloadbranch: this.getBranchList(currentBranchValue),
      dat_fromdate: this.state.formData.dtpfromdate,
      dat_todate: this.state.formData.dtptodate,
      dat_revised_date: revisedDate,
    };
    fetchProposal(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          this.setState(
            {
              ARD: null,
              showRevisedDialog: false,
              selectedProposalRows: [],
            },
            () => {
              this.refreshCurrentTab();
            },
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in Revised Proposal Data. " + error,
        );
      });
  };

  handleARDonActionClick_Revised = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_summarysrno",
      "vac_brname",
      "dat_date_YMD",
      "TblYear",
      "vac_brcode",
      "vac_summary_refno",
      "vac_sitename",
    ]);
    this.setState({
      selectedRow: row,
      showRevisedDialog: true,
    });
  };

  getChildValues = (childValues) => {
    this.setState({
      childValues,
    });
  };

  validateProposalEntry = (formData) => {
    let result = false;
    if (formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Select Date", "dtpDate");
    } else if (
      validatedate_min_max(
        formData.dtpDate,
        "dtpDate",
        this.props.toastErrorMsg,
      ) == false
    ) {
    } else if (formData.cmbEntryBranch.length <= 0) {
      this.props.toastErrorMsg("Select Branch ", "cmbEntryBranch");
    } else if (
      formData.cmbEntryBranch.length > 0 &&
      !isValidItem(this.state.Branches, "vac_brname", formData.cmbEntryBranch)
    ) {
      this.props.toastErrorMsg("Select Valid Branch ", "cmbEntryBranch");
    } else if (formData.txtRef.length <= 0) {
      this.props.toastErrorMsg("Enter Ref. No.", "txtRef");
    } else if (Number(formData.txtUnique) <= 0) {
      this.props.toastErrorMsg("Enter Unique Lift Count", "txtUnique");
    } else if (formData.txtBilling.length <= 0) {
      this.props.toastErrorMsg("Enter Billing Name", "txtBilling");
    } else if (formData.txtBillingAdd.length <= 0) {
      this.props.toastErrorMsg(
        "Enter Billing Address (Without Billing Name)",
        "txtBillingAdd",
      );
    } else if (formData.txtSite.length <= 0) {
      this.props.toastErrorMsg("Enter Site Name", "txtSite");
    } else if (
      formData.txtSite.length > 0 &&
      /[<>:"/\\|?*]/.test(formData.txtSite)
    ) {
      this.props.toastErrorMsg("Dont Use Special Char In Site Name", "txtSite");
    } else if (formData.txtSiteAdd.length <= 0) {
      this.props.toastErrorMsg(
        "Enter Site Address (Without Site Name)",
        "txtSiteAdd",
      );
    } else if (formData.txtCust.length <= 0) {
      this.props.toastErrorMsg("Enter Customer Name", "txtCust");
    } else if (formData.txtCusCity.length <= 0) {
      this.props.toastErrorMsg("Enter Customer City", "txtCusCity");
    } else if (!/^\d{10}$/.test(formData.txtCustPhone)) {
      this.props.toastErrorMsg(
        "Enter a valid 10-digit Customer Phone No.",
        "txtCustPhone",
      );
    } else if (
      formData.txtEmail.length > 0 &&
      !validateEmail(formData.txtEmail)
    ) {
      this.props.toastErrorMsg("Enter a valid Customer Email ID.", "txtEmail");
    } else {
      result = true;
    }
    return result;
  };

  saveProposalEntry = () => {
    this.trimFormData(() => {
      if (this.validateProposalEntry(this.state.childValues)) {
        this.props.notifyProcessing();
        const reqData = {
          Op: "SaveNewProposalEntry",
          bint_uniqueliftcount: this.state.childValues.txtUnique,
          vac_branchname: this.state.childValues.cmbEntryBranch,
          vac_refno: this.state.childValues.txtRef,
          dat_date: this.state.childValues.dtpDate,
          vac_companyname: this.state.childValues.txtBilling,
          vac_companyadd: this.state.childValues.txtBillingAdd,
          vac_sitename: this.state.childValues.txtSite,
          vac_siteaddress: this.state.childValues.txtSiteAdd,
          vac_name: this.state.childValues.txtCust,
          vac_companycity: this.state.childValues.txtCusCity,
          vac_mobileno: this.state.childValues.txtCustPhone,
          vac_emailid: this.state.childValues.txtEmail,
          vac_userid: localStorage.getItem("vac_userid"),
          int_status: 1,
          bol_revision: false,
          bint_totalliftcount: 0,
        };
        fetchProposal(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.setState(
                {
                  bint_summarysrno: res.data.bint_summarysrno,
                },
                () => {
                  this.props.navigateTo("ProposalAllEntry", {
                    bint_summarysrno: this.state.bint_summarysrno,
                    dtpDate: this.state.childValues.dtpDate,
                    cmbBranch: this.state.childValues.cmbEntryBranch,
                    TblYear: res.data.TblYear,
                    vac_brcode: res.data.vac_brcode,
                  });
                },
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in Save Proposal .", error);
          });
      }
    });
  };

  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelPrimary="Save"
          PrimaryIcon={<SaveIcon />}
          labelDisagree="Close"
          alertHeading={"Proposal Entry"}
          alertMessage={<ProposalEntry getChildValues={this.getChildValues} />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
          handleOnClickYes={this.saveProposalEntry}
          handleOnClickNo={() => {}}
          maxWidthClass="100%"
        />
      );
      this.setState({ ARD });
    });
  };

  handleGenerateProposalZip = async () => {
    const selectedRows = this.state.selectedProposalRows;

    if (selectedRows.length === 0) {
      this.props.toastErrorMsg("Please select at least one Proposal.");
      return;
    }

    try {
      this.props.notifyProcessing();
      const zip = new JSZip();

      for (const row of selectedRows) {
        const reqData = [
          { name: "year", value: row.TblYear },
          { name: "vac_refno", value: row.vac_summary_refno },
          { name: "formate", value: "PDF" },
        ];

        const queryString = reqData
          .map(
            (data) =>
              encodeURIComponent(data.name) +
              "=" +
              encodeURIComponent(data.value),
          )
          .join("&");

        const pdfURL = apiURL + "Print?" + queryString;
        const response = await fetch(pdfURL);

        if (!response.ok) {
          throw new Error(
            `Failed to generate PDF for ${row.vac_summary_refno}`,
          );
        }
        const pdfBlob = await response.blob();
        const contentDisposition = response.headers.get("Content-Disposition");

        let fileName = "";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="([^"]+)"/i);
          if (match && match[1]) {
            fileName = match[1];
          }
        }

        if (!fileName) {
          throw new Error(
            `PDF filename was not received from server for ${row.vac_summary_refno}`,
          );
        }

        zip.file(fileName, pdfBlob);
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      const zipURL = window.URL.createObjectURL(zipBlob);
      const link = document.createElement("a");
      link.href = zipURL;
      link.download = "Proposal_PDFs.zip";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(zipURL);

      this.props.updateProcessing(
        "success",
        "Proposal ZIP generated successfully.",
      );
      this.setState({
        selectedProposalRows: [],
      });
    } catch (error) {
      console.error("Error while generating Proposal ZIP:", error);
      this.props.updateProcessing(
        "error",
        "Error while generating Proposal ZIP. " + error.message,
      );
    }
  };

  handleOnChangeTab = (event, newValue) => {
    this.setState(
      {
        formData: { ...this.state.formData, listTab: newValue },
        selectedProposalRows: [],
      },
      () => {
        const rows =
          newValue === "date" ? this.state.dateRows : this.state.sequenceRows;
        if (rows.length === 0) {
          this.loadProposalList(newValue);
        }
      },
    );
  };

  renderTableActions = () => {
    const actions = [];

    if (this.props.userPrivilege["Entry:Proposal"] != "R") {
      actions.push({
        label: "Add New Proposal",
        onClick: this.handleOnNewEntryClick,
        addPluseIcon: true,
      });
    }

    actions.push({
      label: "Generate Proposal ZIP",
      onClick: this.handleGenerateProposalZip,
      disabled: this.state.selectedProposalRows.length === 0,
    });

    return actions;
  };

  renderProposalTable = () => {
    return (
      <CtART
        rowsdata={this.getCurrentRows()}
        columnsdata={this.state.columnsdata}
        rowsPerPage={this.state.rowsPerPage}
        tblmaxHeight={500}
        csvFileName={csvFileName("Proposal")}
        rowIconAction={[
          {
            label: "Select",
            onClick: this.handleProposalCheckbox,
            checked: (row) =>
              this.state.selectedProposalRows.some(
                (item) =>
                  item.bint_summarysrno === row.original.bint_summarysrno &&
                  item.vac_brname === row.original.vac_brname &&
                  item.TblYear === row.original.TblYear,
              ),
          },
          {
            label: "Edit",
            onClick: this.handleARDonActionClick_Edit,
            icon: "Edit",
            className: "secondary-button",
          },
          {
            label: "Print",
            onClick: (row) => {
              this.print(row, "PRINT");
            },
            icon: "print",
          },
          {
            label: "PDF",
            onClick: (row) => {
              this.print(row, "PDF");
            },
            icon: "Pdf",
          },
          {
            label: "Revise",
            onClick: this.handleARDonActionClick_Revised,
            icon: "revise",
          },
          this.props.userPrivilege["Entry:Proposal"] == "M"
            ? {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              }
            : "",
        ]}
        tableButtonAction={this.renderTableActions()}
        showColumnFilters={false}
        actionColSize={230}
        hideColIdList={["dat_date_YMD", "vac_brcode", "TblYear"]}
        density={"compact"}
        enablePagination={false}
        onTableScroll={this.handleProposalTableScroll}
      />
    );
  };

  render() {
    return (
      <form>
        {this.state.showRevisedDialog && (
          <AlertResponsiveDialog
            labelPrimary="Revised Proposal"
            PrimaryIcon={<FileCopy />}
            labelDisagree="Cancel"
            alertHeading={"Proposal Revised"}
            alertMessage={
              <>
                <CtDtp
                  id="dtpRevisedDate"
                  name="dtpRevisedDate"
                  value={this.state.formData.dtpRevisedDate}
                  label="Select Revised Date *"
                  handleOnChange={this.handleOnChange}
                  onKeyDown={this.props.onKeyDown}
                />

                <Typography variant="h6">
                  Do you want to revised proposal Ref.NO:{" "}
                  {this.state.selectedRow?.vac_summary_refno}
                </Typography>

                <Typography variant="h6" sx={{ mb: 2 }}>
                  Site Name : {this.state.selectedRow?.vac_sitename}
                </Typography>
              </>
            }
            handleOnClickYes={() => {
              if (!this.state.formData.dtpRevisedDate) {
                this.props.toastErrorMsg("Please select revised date");
                return;
              }

              const row = this.state.selectedRow;
              this.revised(
                row.bint_summarysrno,
                row.vac_summary_refno,
                row.vac_brname,
                row.dat_date_YMD,
                this.state.formData.dtpRevisedDate,
              );
            }}
            handleOnClickNo={() => {
              this.setState({ showRevisedDialog: false });
            }}
            defaultOpenDialog={true}
          />
        )}

        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={this.state.formData.listTab}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={this.handleOnChangeTab}>
                <Tab label="Date Wise" value="date" />
                <Tab label="Ref No Wise" value="sequence" />
              </TabList>
            </Box>

            <TabPanel value="date" sx={{ px: 0 }}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                spacing={3}
              >
                <Grid item>
                  <CtDtp
                    id="dtpfromdate"
                    value={this.state.formData.dtpfromdate}
                    label="From Date*"
                    handleOnChange={this.handleOnChange}
                    maxLength={50}
                    onKeyDown={this.props.onKeyDown}
                    width={150}
                  />
                </Grid>
                <Grid item>
                  <CtDtp
                    id="dtptodate"
                    value={this.state.formData.dtptodate}
                    label="To Date*"
                    handleOnChange={this.handleOnChange}
                    maxLength={50}
                    onKeyDown={this.props.onKeyDown}
                    width={150}
                  />
                </Grid>
                <Grid item>
                  <CtCmbEditable
                    id="cmbDateBranch"
                    label="Branch *"
                    items={this.state.Branches}
                    value={this.state.formData.cmbDateBranch}
                    handleOnChange={this.handleOnChange}
                    width={190}
                    maxLength={100}
                    colID="vac_brname"
                  />
                </Grid>
                <Grid item marginTop={1}>
                  <CtBtn
                    label={"Load"}
                    firstletterBig={false}
                    variant={"outlined"}
                    className={"child-button"}
                    iconName={"load"}
                    onClick={() => this.loadProposalList("date")}
                  />
                </Grid>
              </Grid>
            </TabPanel>

            <TabPanel value="sequence" sx={{ px: 0 }}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                spacing={3}
              >
                <Grid item>
                  <CtCmbEditable
                    id="cmbSequenceBranch"
                    label="Branch *"
                    items={this.state.Branches}
                    value={this.state.formData.cmbSequenceBranch}
                    handleOnChange={this.handleOnChange}
                    width={190}
                    maxLength={100}
                    colID="vac_brname"
                  />
                </Grid>
                <Grid item>
                  <CtTxt
                    id="txtSiteSearch"
                    value={this.state.formData.txtSiteSearch}
                    label="Site Name"
                    handleOnChange={this.handleOnChange}
                    maxLength={100}
                    width={260}
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>
                <Grid item marginTop={1}>
                  <CtBtn
                    label={"Load"}
                    firstletterBig={false}
                    variant={"outlined"}
                    className={"child-button"}
                    iconName={"load"}
                    onClick={() => this.loadProposalList("sequence")}
                  />
                </Grid>
              </Grid>
            </TabPanel>
          </TabContext>
        </Box>

        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          className="title"
          marginTop={2}
        >
          <Grid item marginBottom={1}>
            <Typography variant="body2">
              Showing {this.getCurrentRows().length} of{" "}
              {this.getCurrentTotalCount()} proposals
            </Typography>
          </Grid>
          <Grid item className="maintable" sx={{ width: "100%" }}>
            {this.renderProposalTable()}
          </Grid>
          <Grid item>
            <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
              {this.state.ARD}
            </Box>
          </Grid>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <Proposal {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
